export {};

export const PATH_LOCAL_SPACE = "/auditspace";